<template>
  <svg
    width="20px"
    height="17px"
    viewBox="0 0 20 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>购物车</title>
    <desc>Created with Sketch.</desc>
    <g id="配件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="2-1-常备件清单" transform="translate(-1576.000000, -561.000000)">
        <g id="购物车" transform="translate(1576.000000, 559.500000)">
          <rect
            id="矩形备份-7"
            fill="#FFFFFF"
            opacity="0"
            x="0"
            y="0"
            width="20"
            height="20"
          ></rect>
          <path
            d="M14.89858,14.3020672 L2.56680305,14.3020672 L2.56680304,14.3020672 C2.27174377,14.2828184 2.03636885,14.0483735 2.01595323,13.7533924 C2.01595323,13.7533924 1.16938478,9.04798775 0.783791163,5.80811387 C0.672896514,4.9108095 1.09618012,4.47230496 1.92317983,4.47230496 L15.394347,4.47230496 L15.616136,2.54939938 L15.616136,2.54939981 C15.6265395,2.26377647 15.8457265,2.02943905 16.1300202,2 L18.6110193,2 L18.6110193,2 C18.9548739,2 19.2336238,2.2787499 19.2336238,2.62260447 C19.2336238,2.96645904 18.9548739,3.24520894 18.6110193,3.24520894 C18.6110193,3.24520894 18.6110193,3.24520894 18.6110193,3.24520894 L16.6808793,3.24520894 L15.4313219,13.7548303 L15.4313219,13.7548304 C15.4241041,14.0483319 15.1918142,14.2866255 14.8985924,14.3013302 L14.89858,14.3020672 Z M1.98116263,5.69649204 C2.31384689,8.29635051 2.8632467,11.7746774 3.08358569,13.0713488 L14.3651286,13.0713488 L15.2450377,5.69649204 L1.98116263,5.69649204 Z M14.291924,15.5472564 L14.291924,15.5472564 C14.9692191,15.5504722 15.5156782,16.1021244 15.5124907,16.7794194 C15.5092743,17.4567145 14.9576222,18.0031737 14.2803271,17.9999861 C13.6053008,17.9967805 13.0597619,17.4486692 13.0597619,16.7736351 L13.0597619,16.7736215 C13.0597619,16.0963187 13.6088242,15.5472564 14.2861255,15.5472564 C14.2880629,15.5472564 14.2900003,15.5472564 14.2919376,15.5472564 L14.291924,15.5472564 Z M3.17347472,15.5472564 L3.17347473,15.5472564 C3.85076981,15.5504722 4.39722899,16.1021244 4.39404143,16.7794194 C4.39082506,17.4567145 3.83917294,18.0031737 3.16187786,17.9999861 C2.48685153,17.9967805 1.94131266,17.4486692 1.94131266,16.7736351 L1.94131266,16.7736215 C1.94131266,16.0963187 2.49037497,15.5472564 3.1676763,15.5472564 C3.16961367,15.5472564 3.17155104,15.5472564 3.17348839,15.5472564 L3.17347472,15.5472564 Z"
            id="形状"
            fill="currentColor"
            fill-rule="nonzero"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Cart'
});
</script>
